import type { CSSProperties } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { Overlay } from '../../components/Overlay/Overlay';
import { Tooltip } from '../../components/Tooltip/Tooltip';
import { useOpenDailyBonus } from '../../hooks/useOpenDailyBonus';
import { analytics } from '../../services/analytics';
import { useStores } from '../../stores/useStores';

import { ONBOARDING_CONFIG } from './constants';
import styles from './Onboarding.module.scss';
import { RedeemTooltip } from './tooltips/RedeemTooltip';
import { RewardsTooltip } from './tooltips/RewardsTooltip';

export const MenuOnboarding = observer(
  (props: {
    setPopperElement: (el: HTMLElement | null) => void;
    tooltipStyles: CSSProperties;
    overlayClassName?: string;
  }) => {
    const { onboardingStore, uiStore, rewardsStore, coinTypeStore } = useStores();

    const { openDailyBonus } = useOpenDailyBonus(true);

    const handleRedeemClick = () => {
      void analytics.sendEvent('onboarding_next_step_click', {
        event_parent: 'ftue',
        step: 'redeem_button',
      });
      coinTypeStore.setCoinType('GC');
      onboardingStore.nextStep();
      uiStore.setOpenFullPageDialog('rewards');
    };

    const handleDailyRewardsClick = () => {
      void analytics.sendEvent('onboarding_next_step_click', {
        event_parent: 'ftue',
        step: 'rewards_button',
      });
      uiStore.setOpenFullPageDialog(null);
      uiStore.setSideMenuOpen(false);

      if (rewardsStore.dailyBonus?.isEntitledToBonus && rewardsStore.dailyBonus.currentDay === 0) {
        onboardingStore.nextStep();
        openDailyBonus();
      } else {
        onboardingStore.setStep(ONBOARDING_CONFIG.START_GAME);
      }
    };

    return (
      <Overlay
        backdropClassName={styles.overlayBackdrop}
        className={classNames(styles.overlay, props.overlayClassName)}
      >
        <Tooltip setTooltipRef={props.setPopperElement} tooltipPositionStyle={props.tooltipStyles}>
          {onboardingStore.step === ONBOARDING_CONFIG.REDEEM && <RedeemTooltip handleClick={handleRedeemClick} />}
          {onboardingStore.step === ONBOARDING_CONFIG.REWARDS && (
            <RewardsTooltip handleClick={handleDailyRewardsClick} />
          )}
        </Tooltip>
      </Overlay>
    );
  },
);
